import GoBackToListButton from '../../../../../../components/buttons/GoBackToListButton';
import TeacherDetailBox from './TeacherDetailBox';

const HeaderInfo = ({ path }: { path: string }) => {
  return (
    <div className="d-flex align-items-center justify-content-between mb-4">
      <GoBackToListButton path={path} />
      <TeacherDetailBox />
    </div>
  );
};

export default HeaderInfo;
